import PubSub from "underpub-js";

var FloorplanListing = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-FloorplanListing',
	};

	$.extend(true, this.options, options);

};

FloorplanListing.prototype.init = function() {

	var self = this;
	var $tabsWrapper = this.options.$el.find('[data-tabs-id="floorplans"]');
	
	if (!$tabsWrapper.length) {
		return;
	}

	// Prevent Webflow from handling these tabs
	$tabsWrapper.attr('data-w-tabs-disabled', 'true');

	var $tabLinks = $tabsWrapper.find('[data-tab]');
	var $tabPanes = $tabsWrapper.find('[data-panel]');
	
	// Track if we're in the middle of a tab switch to prevent scroll
	var isSwitchingTab = false;
	var savedScrollPosition = 0;

	// Function to switch tabs
	function switchTab(tabSlug, updateHash) {
		// Remove active classes
		$tabLinks.removeClass('w--current');
		$tabPanes.removeClass('w--tab-active');

		// Find and activate the selected tab
		var $activeLink = $tabLinks.filter('[data-tab="' + tabSlug + '"]');
		var $activePane = $tabPanes.filter('[data-panel="' + tabSlug + '"]');

		if ($activeLink.length && $activePane.length) {
			$activeLink.addClass('w--current');
			$activePane.addClass('w--tab-active');
			
			// Update hash if requested (for deep linking)
			if (updateHash !== false) {
				var newHash = '#floorplans=' + tabSlug;
				if (window.history && window.history.replaceState) {
					window.history.replaceState(null, null, newHash);
				}
			}
		}
	}

	// Scroll prevention during tab switch
	var scrollPreventionTimeout;
	var scrollPreventionHandler;
	
	function preventScrollDuringSwitch() {
		isSwitchingTab = true;
		savedScrollPosition = window.scrollY || window.pageYOffset;
		
		// Clear any existing timeout
		if (scrollPreventionTimeout) {
			clearTimeout(scrollPreventionTimeout);
		}
		
		// Remove existing scroll handler if any
		if (scrollPreventionHandler) {
			$(window).off('scroll', scrollPreventionHandler);
		}
		
		// Create scroll prevention handler
		scrollPreventionHandler = function() {
			if (isSwitchingTab) {
				window.scrollTo(0, savedScrollPosition);
			}
		};
		
		// Attach scroll prevention
		$(window).on('scroll', scrollPreventionHandler);
		
		// Restore scroll position aggressively
		var restoreScroll = function() {
			if (isSwitchingTab) {
				window.scrollTo(0, savedScrollPosition);
			}
		};
		
		// Restore immediately and multiple times
		restoreScroll();
		setTimeout(restoreScroll, 0);
		setTimeout(restoreScroll, 10);
		setTimeout(restoreScroll, 50);
		setTimeout(restoreScroll, 100);
		requestAnimationFrame(restoreScroll);
		requestAnimationFrame(function() {
			restoreScroll();
		});
		
		// Stop preventing after a short delay
		scrollPreventionTimeout = setTimeout(function() {
			isSwitchingTab = false;
			if (scrollPreventionHandler) {
				$(window).off('scroll', scrollPreventionHandler);
				scrollPreventionHandler = null;
			}
		}, 300);
	}

	// Handle tab link clicks - use capture phase to run before Sitewide
	$tabLinks.each(function() {
		this.addEventListener('click', function(e) {
			e.preventDefault();
			e.stopPropagation();
			e.stopImmediatePropagation();
			
			var tabSlug = $(this).attr('data-tab');
			if (tabSlug) {
				// Save scroll position BEFORE doing anything
				var scrollY = window.scrollY || window.pageYOffset;
				
				// Prevent scroll during switch
				preventScrollDuringSwitch();
				
				// Switch the tab WITHOUT updating hash (prevents any hash-based scrolling)
				switchTab(tabSlug, false);
				
				// Update hash AFTER a delay to avoid triggering scroll
				setTimeout(function() {
					var newHash = '#floorplans=' + tabSlug;
					if (window.history && window.history.replaceState) {
						window.history.replaceState(null, null, newHash);
					}
					// Restore scroll position after hash update
					window.scrollTo(0, scrollY);
				}, 100);
			}
			
			return false;
		}, true); // Use capture phase (true) to run before other handlers
	});

	// Handle initial hash on page load
	function handleHash() {
		var hash = window.location.hash;
		if (hash && hash.indexOf('floorplans=') !== -1) {
			var tabSlug = hash.split('=')[1];
			if (tabSlug) {
				// Switch tab but don't update hash (it's already in URL)
				switchTab(tabSlug, false);
			}
		}
	}

	// Check hash on load
	handleHash();

	// Listen for hash changes (back/forward buttons)
	$(window).on('hashchange', function() {
		// Prevent scroll when hash changes via back/forward
		preventScrollDuringSwitch();
		handleHash();
	});

};

export default FloorplanListing;
